import axiosClient from './axiosClient';

export const ticketsService = {
  list: (status) => axiosClient.get('/tickets', { params: status ? { status_filter: status } : {} }),
  create: (payload) => axiosClient.post('/tickets', payload),
  get: (id) => axiosClient.get(`/tickets/${id}`),
  addMessage: (id, payload) => axiosClient.post(`/tickets/${id}/messages`, payload),
  updateStatus: (id, payload) => axiosClient.patch(`/tickets/${id}`, payload),
  getAudit: (id) => axiosClient.get(`/tickets/${id}/audit`),
};
